<div [ngStyle]="{'background-color': dealBackgroundColor}">
  <section *ngIf="filteredDetail.length > 0">
    <div class="page-toolbar container px-3 py-2 d-flex align-items-center justify-content-between flex-wrap gap-2">
      <button type="button" class="btn btn-deals featured-back-btn" (click)="goBackToFeaturedList()">
        <!-- <i class="bx bx-list-ul" style="position:relative; top:1px;"></i> -->
        <i class="fa-solid fa-arrow-left ms-1" style="position:relative; top:1px;"></i>
        &nbsp; Back To List


      </button>
    </div>
    <div class="container px-2 px-sm-3 px-md-0" *ngFor="let item of filteredDetail">
      <div class="row gx-3 gy-4">
        <div class="col-lg-8 col-md-7 col-sm-12">
          <div class="card shadow-sm rounded-3  mt-2 p-4">
            <div class="product-video text-center mb-4">
              <ng-container *ngIf="(item.featureOptionalVideos?.length || 0) > 0; else videoLinkBlock">
                <video *ngFor="let video of item.featureOptionalVideos" class="img-fluid w-100 product-vdo" controls
                  preload="metadata" playsinline>
                  <source [src]="getVideoFileSrc(video)" [type]="guessMime(video)" />
                  Your browser does not support the video tag.
                </video>
              </ng-container>
              <ng-template #videoLinkBlock>
                <ng-container *ngIf="item.featureVideoLink as link">
                  <ng-container *ngIf="isYouTube(link); else directVideo">

                    <iframe *ngIf="youtubeEmbedUrl" class="yt-embed__el vdo" [src]="youtubeEmbedUrl" frameborder="0"
                      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen>
                    </iframe>
                    <!-- <div class="yt-embed" *ngIf="youtubeEmbedUrl">
                        
                        <iframe
                          class="yt-embed__el vdo"
                          [src]="youtubeEmbedUrl"
                          frameborder="0"
                          loading="lazy"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen>
                         </iframe>
                      

                    </div> -->

                  </ng-container>
                  <ng-template #directVideo>
                    <video width="320" height="240" autoplay=""
                      poster="https://cdn.shopify.com/s/files/1/0722/5065/4889/files/Kurthi4.jpg?v=1761305290">
                      <source [src]="getVideoPoster(link)" type="video/mp4">
                    </video>
                  </ng-template>
                </ng-container>
              </ng-template>
            </div>
            <div class="deal-image mb-4">
              <owl-carousel-o [options]="productImagesOptions">
                <ng-container>
                  <ng-template carouselSlide *ngFor="let img of getAllImages(item)">
                    <img class="mt-3" [src]="absoluteUrl(img?.src) || 'assets/img/no-image.png'" class="deal-img"
                      alt="Optional Image" />


                  </ng-template>

                </ng-container>
              </owl-carousel-o>

            </div>


            <div class="col-xl-12  col-lg-12  col-md-12">
              <aside class="widget-area-mobile mt-2">
                <ul class="social">
                  <span *ngIf="item?.buyOn && item?.buyOn.length">Buy Online:</span>
                  <li *ngFor="let buyon of getSortedBuyOn(item.buyOn)" class="mx-2">
                    <a *ngIf="buyon.buyOnName === 'Shopify' && buyon.buyOnUrl !=''" [href]="buyon.buyOnUrl"
                      matTooltip="Buy on Shopify" target="_blank" rel="noopener" class="market-place">
                      <img class="profile-img mt-3" [src]="company_logo || 'assets/img/shopify-logo.png'"
                        alt="Profile Image" class="buyon-circle" />
                      <!-- <i class="bx bxl-shopify"></i> -->
                    </a>
                    <a *ngIf="buyon.buyOnName === 'Amazon' && buyon.buyOnUrl" [href]="buyon.buyOnUrl" target="_blank"
                      rel="noopener" matTooltip="Buy on Amazon" class="market-place">
                      <img src="assets/icons/amazon.png" class="buyon-circle" />

                    </a>

                    <a *ngIf="buyon.buyOnName === 'eBay' && buyon.buyOnUrl !=''" [href]="buyon.buyOnUrl"
                      matTooltip="Buy on eBay" target="_blank" rel="noopener" class="market-place">
                      <img src="assets/img/ebay.jpg" alt="eBay" class="buyon-circle">
                      <!-- <i class="bx bxl-ebay"></i> -->
                    </a>

                    <a *ngIf="buyon.buyOnName === 'Flipkart' && buyon.buyOnUrl != ''" [href]="buyon.buyOnUrl"
                      matTooltip="Buy on Flipkart" target="_blank" rel="noopener" class="market-place">
                      <img src="assets/icons/flipkart.png" class="flipkart" class="buyon-circle" />
                    </a>



                  </li>
                </ul>


              </aside>
            </div>

            <!-- Variant Dropdown -->

            <!-- <span
          class="variant-value-pill"
          *ngFor="let value of getAttributeValues(header.id)"
          (click)="onVariantValueClick(header.id, value)">
          {{ value }}
        </span> -->

            <!-- <button
  class="variant-attr-pill"
  [class.active]="openedAttributeIds.has(header.id)"
  (click)="toggleAttribute(header.id)">
  {{ header.name }}
  <span class="arrow" [class.open]="openedAttributeIds.has(header.id)">▼</span>
</button> -->

            <!-- <div *ngIf="hasVariantGroupData" class="variant-attr-wrapper">

  <div class="variant-attr-list">

    <div
      class="variant-attr-item"
      *ngFor="let header of visibleHeaders">

<button
  type="button"
  class="variant-attr-pill"
  aria-expanded="{{ openedAttributeIds.has(header.id) }}"
  [class.active]="openedAttributeIds.has(header.id)"
  (click)="toggleAttribute(header.id)">
  {{ header.name }}
  <span class="arrow" [class.open]="openedAttributeIds.has(header.id)">▼</span>
</button>

<div
  class="variant-values"
  *ngIf="openedAttributeIds.has(header.id)"
  @expandCollapse>

  <span
  class="variant-value-pill"
  *ngFor="let value of getAttributeValues(header.id)"
  (click)="$event.stopPropagation(); onVariantValueClick(header.id, value)">
  {{ value }}
</span>

      </div>

    </div>

  </div>

</div> -->

            <div *ngIf="hasVariantGroupData" class="variant-attr-wrapper">

              <div class="variant-attr-list">

                <div class="variant-attr-item" *ngFor="let header of visibleHeaders">


                  <button *ngIf="header.id !== 'price' || showPriceOnOffer" type="button" class="variant-attr-pill"
                    aria-expanded="{{ openedAttributeIds.has(header.id) }}"
                    [class.active]="openedAttributeIds.has(header.id)" [class.selected]="selectedAttributes[header.id]"
                    (click)="toggleAttribute(header.id)">

                    <span class="floating-label" *ngIf="selectedAttributes[header.id]">
                      {{ header.name }}
                      <span class="required-star">*</span>
                    </span>

                    <span class="selected-text">
                      {{ selectedAttributes[header.id] || header.name }}
                    </span>

                    <span class="arrow" [class.open]="openedAttributeIds.has(header.id)">▼</span>
                  </button>


                  <div class="variant-values" *ngIf="
                 openedAttributeIds.has(header.id) &&
                (header.id !== 'price' || hasPriceValues())
                 " @expandCollapse>
                    <span class="variant-value-pill"
                      *ngFor="let value of getAttributeValues(header.id); trackBy: trackByValue"
                      [class.selected]="selectedAttributes[header.id] === value"
                      (click)="$event.stopPropagation(); onVariantValueClick(header.id, value)">
                      <ng-container *ngIf="header.id !== 'price'">
                        {{ value.name }}
                      </ng-container>

                      <ng-container *ngIf="header.id === 'price'">
                        ₹{{ value.price }}
                      </ng-container>
                    </span>
                  </div>

                </div>


                <button type="button" *ngIf="item?.isCartItem && areAllAttributesSelected()"
                  class="col-lg-8 col-md-8 col-sm-8 col-8 mb-2"
                  [ngClass]="item.isWishList ? 'default-custom-lock-btn' : 'default-custom-btn'"
                  (click)="onAddToCart(item)">
                  <i class="bx bxs-cart-add"></i>
                </button>

              </div>

            </div>

            <!--  <table *ngIf="hasVariantGroupData" class="neumo-safe-table" border="1" cellpadding="8"
              (click)="toggleTable()">
              <thead>
                <tr>
                  <th *ngFor="let header of visibleHeaders">
                    {{ header.name }}
                    <span class="arrow" [class.open]="isTableOpen">▼</span>
                  </th>
                </tr>
              </thead>
              <tbody *ngIf="isTableOpen" @expandCollapse>
                <tr *ngFor="let row of tableRows">
                  <td class="highlight" *ngFor="let header of visibleHeaders">
                    {{ row[header.id] }}
                  </td>
                </tr>
              </tbody>
            </table> -->


            <div class="deal-info  mt-4 mb-3" *ngIf="safeDescription">
              <div class="richtext-output mx-auto">
                <div class="rt-body" [innerHTML]="safeDescription"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-5 col-sm-12 ">
          <div class="sticky-wrapper">
            <div class="deal-sidebar card shadow-sm rounded-3 p-4 text-center">
              <div class="profile-block d-flex flex-column align-items-center text-center">
                <div class="profile-image mb-2">
                  <img class="mt-3" [src]="img.src || 'assets/img/no-image.png'" *ngFor="let img of item.featureImages"
                    alt="Profile Image" class="profile-img" />

                </div>
                <button type="button" *ngIf="item?.isCartItem && areAllAttributesSelected()"
                  class="col-lg-8 col-md-8 col-sm-8 col-8 mb-2"
                  [ngClass]="item.isWishList ? 'default-custom-lock-btn' : 'default-custom-btn'"
                  (click)="onAddToCart(item)">
                  <i class="bx bxs-cart-add"></i>
                </button>
                <div class="profile-meta">

                  <div class="name"><strong>{{ item.feature_contact_name }}</strong></div>
                  <div class="designation"><strong>{{ item.feature_contact_designation }}</strong></div>
                </div>
                <div class="profile-actions mt-2 d-flex flex-column align-items-center text-center">


                  <div class="col-12 col-md-auto">
                    <div class="wp-image text-center mb-2">
                      <a [href]="whatsappURL" target="_blank" rel="noopener">
                        <i><img [src]="wpImage" alt="WhatsApp" class="wp-img" /></i>
                      </a>
                    </div>
                    <div class="wp-image text-center mb-2">
                      <button class="vcard-btn" (click)="downloadVcard()"><mat-icon>get_app</mat-icon> &nbsp; &nbsp;
                        &nbsp; vCard</button>
                    </div>

                    <div class="wp-image text-center" *ngIf="showUpi">
                      <button class="upi-btn" (click)="openUpi()">
                        <span>Pay via </span>
                        <img class="mt-3" [src]="upiImg" alt="UPI" style="height: 24px;" />
                      </button>
                    </div>
                  </div>

                  <div class="deal-share mt-4 d-flex align-items-center" *ngIf="hasAnySocialLinks">

                    <ul class="social" *ngIf="false">
                      <li *ngIf="social.website">
                        <a [href]="social.website" target="_blank" matTooltip="Web site" rel="noopener"><i
                            class="bx bx-globe"></i></a>
                      </li>
                      <li *ngIf="social.facebook">
                        <a [href]="social.facebook" class="facebook" matTooltip="Facebook" target="_blank"
                          rel="noopener"><i class="bx bxl-facebook"></i></a>
                      </li>
                      <li *ngIf="social.instagram">
                        <a [href]="social.instagram" class="instagram" matTooltip="Instagram" target="_blank"
                          rel="noopener"><i class="bx bxl-instagram"></i></a>
                      </li>
                      <li *ngIf="social.twitter">
                        <a [href]="social.twitter" class="twitter" matTooltip="Twitter" target="_blank"
                          rel="noopener"><i class="bx bxl-twitter"></i></a>
                      </li>
                      <li *ngIf="social.tiktok">
                        <a [href]="social.tiktok" class="tiktok" matTooltip="Tiktok" target="_blank" rel="noopener"><i
                            class="bx bxl-tiktok"></i></a>
                      </li>
                      <li *ngIf="social.pinterest">
                        <a [href]="social.pinterest" class="pinterest" matTooltip="Pinterest" target="_blank"
                          rel="noopener"><i class="bx bxl-pinterest"></i></a>
                      </li>
                      <li *ngIf="social.linkedin">
                        <a [href]="social.linkedin" class="linkedin" matTooltip="Linkedin" target="_blank"
                          rel="noopener"><i class="bx bxl-linkedin"></i></a>
                      </li>
                      <li *ngIf="social.youTube">
                        <a [href]="social.youTube" class="youtube" matTooltip="Youtube" target="_blank" rel="noopener">
                          <i class="bx bxl-youtube"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#" class="copy" matTooltip="Copy" (click)="onCopyClick($event, productOrRow)">
                          <i class="bx bx-copy-alt"></i>
                        </a>
                      </li>
                      <li *ngIf="social.buyonline">
                        <a [href]="social.buyonline" class="instagram" matTooltip="Buy Online" target="_blank"
                          rel="noopener">
                          <i class="bx bx-shopping-bag"></i>
                        </a>
                      </li>

                      <li *ngIf="social.amazon">
                        <a [href]="social.amazon" target="_blank" rel="noopener" matTooltip="Amazon"
                          class="market-place">
                          <img src="assets/icons/amazon.png" class="amazon" />
                        </a>
                      </li>
                      <li *ngIf="social.flipkart">
                        <a [href]="social.flipkart" matTooltip="Flipkart" target="_blank" rel="noopener"
                          class="market-place">
                          <img src="assets/icons/flipkart.png" class="flipkart" />
                        </a>
                      </li>




                      <li *ngIf="social.buyonline">
                        <a [href]="social.buyonline" class="instagram" matTooltip="Buy Online" target="_blank"
                          rel="noopener">
                          <i class="bx bx-shopping-bag"></i>
                        </a>
                      </li>
                      <li *ngIf="social.Amazon">
                        <a [href]="social.Amazon" class="instagram" matTooltip="Amazon" target="_blank" rel="noopener">
                          <i class="bx bxl-amazon"></i>
                        </a>
                      </li>
                      <li *ngIf="social.Flipkart">
                        <a [href]="social.Flipkart" class="instagram" matTooltip="Flipkart" target="_blank"
                          rel="noopener">
                          <i class="bx bx-store"></i>
                        </a>
                      </li>
                      <li (click)="openShareDialog(shareDialog, $event)"><a title="share" class="share"><img
                            src="assets/img/shareIcon.png" alt="shareImage" class="icon" /></a></li>
                    </ul>


                  </div>
                  <ng-template #shareDialog>
                    <div class="share-dialog-content">
                      <ul>
                        <li>
                          <a target="_blank" rel="noopener" class="facebook-icon" (click)="shareOnFacebook(item)">
                            <i class="fab fa-facebook"></i>
                          </a>
                        </li>
                        <li *ngIf="social.buyonline">
                          <a [href]="social.buyonline" class="instagram" matTooltip="Buy Online" target="_blank"
                            rel="noopener">
                            <i class="bx bx-shopping-bag"></i>
                          </a>
                        </li>
                        <li *ngIf="social.Amazon">
                          <a [href]="social.Amazon" class="instagram" matTooltip="Amazon" target="_blank"
                            rel="noopener">
                            <i class="bx bxl-amazon"></i>
                          </a>
                        </li>
                        <li *ngIf="social.Flipkart">
                          <a [href]="social.Flipkart" class="instagram" matTooltip="Flipkart" target="_blank"
                            rel="noopener">
                            <i class="bx bx-store"></i>
                          </a>
                        </li>
                        <li (click)="openShareDialog(shareDialog, $event)"><a title="share" class="share"><img
                              src="assets/img/shareIcon.png" alt="shareImage" class="icon" /></a></li>
                      </ul>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</div>